import { panelListSelectedDataChangeTransaction } from 'common/actions';
import { MapDispatchToProps, connect } from 'react-redux';
import SelectionList from '../components';
import { ISelectionListCProps } from '../entities';

const mapDispatchToProps: MapDispatchToProps<ISelectionListCProps, never> = dispatch => {
	return {
		onSelectedChange: data => {
			dispatch(panelListSelectedDataChangeTransaction(data));
		}
	};
};

const SelectionListContainer = connect(null, mapDispatchToProps)(SelectionList);

export default SelectionListContainer;
